<template>
  <div :class="['price-box', callToAction.align]" v-if="callToAction">
    <div class="price-box-view">
      <span v-if="callToAction.currency" class="symbol">{{ callToAction.currency }}</span>
      <span v-if="callToAction.value" class="main-price">{{ callToAction.value }}</span>
      <span v-if="callToAction.cents" class="cents">{{ callToAction.cents }}</span>
    </div>
    <div v-if="callToAction.links" class="price-box-links">
      <a v-for="(link, index) in callToAction.links" :key="index" class="buy-now" :href="link.url">{{ link.label }}</a>
    </div>
  </div>    
</template>

<script>

import gql from 'graphql-tag'

export default {
  name: 'CallToAction',
  data() {
    return {
      callToAction: {}
    }
  },
  props: [
    'id'
  ],
  apollo: {
    callToAction: {
      query: gql`query CallToAction ($id: ItemId) {
        callToAction(filter: {id: {eq: $id}}) {
          currency
          value
          cents
          align
          links {
            label
            url
            image { url }
          }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.price-box {
  font-family: 'LeagueGothicRegular',Helvetica,sans-serif;
  padding: 0 40px 20px;

  &.left {
    float: left;
  }

  &.right {
    float: right;
  }

  & .price-box-view {
    font-size: 15px;
    line-height: 20px;

    & span {
      display: inline-block;
      float: none;
      font-size: 45px;
      line-height: 50px;
      margin: 0;
      padding-top: 12px;
      vertical-align: text-top;

      &.main-price {
        font-size: 90px;
        line-height: 90px;
        padding-top: 7px;
      }
    }
  }

  & .price-box-links {
    font-size: 15px;
    line-height: 20px;
    margin: 1.2em 0;

    & a {
      background: none repeat scroll 0 0 #74CDCE;
      color: #000000;
      font-family: 'LeagueGothicRegular',Helvetica,sans-serif;
      font-size: 30px;
      line-height: 32px;
      padding: 3px 18px;
      text-decoration: none;
      text-transform: uppercase;
      display: block;
      margin: 5px 0;

      &:hover {
        background: none repeat scroll 0 0 #000000;
        color: #74CDCE;
        text-decoration: none;
      }
    }
  }
}
</style>
